import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import JourneySection from '~/components/LandingPage/JourneySection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'
import BoostSection from '~/components/Solutions/BoostSection'
import CostEfficiencySection from '~/components/Solutions/CostEfficiencySection'
import RecruitmentAgenciesSection from '~/components/Solutions/RecruitmentAgenciesSection'
import RecruitmentPlacementSection from '~/components/Solutions/RecruitmentPlacementSection'
import SafeguardSection from '~/components/Solutions/SafeguardSection'
import SolutionsRecruitmentAgencySection from '~/components/Solutions/SolutionsRecruitmentAgencySection'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const RecruitmentAgencyContainer = () => {
  return (
    <LayoutLandingPage>
      <SolutionsRecruitmentAgencySection />

      <LazyLoadWrapper height={300} once>
        <RecruitmentAgenciesSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <RecruitmentPlacementSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <CostEfficiencySection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <BoostSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <SafeguardSection />
      </LazyLoadWrapper>

      <LazyLoadWrapper height={300} once>
        <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
      </LazyLoadWrapper>
    </LayoutLandingPage>
  )
}

export default RecruitmentAgencyContainer
